import 'react-app-polyfill/ie9'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './app/App'
import * as serviceWorker from './serviceWorker'
// eslint-disable-next-line no-unused-vars
import * as globalHelpers from './helper'
import './i18n'
import { UnreadMessagesContext, UnreadMessagesProvider } from './context/UnreadMessagesContext'
import { EndConversationModalProvider } from './context/EndConversationContext'
import { FeedbackModalProvider } from './context/FeedbackModalContext'
import { AriaLiveProvider } from './context/AriaLiveContext'

import { datadogRum } from '@datadog/browser-rum-slim'
import { datadogLogs } from '@datadog/browser-logs'

const IS_DD_ENABLED = 'REPLACE_IS_DD_ENABLED'.trim() === 'true'
const DD_APPLICATION_ID = 'REPLACE_DD_APPLICATION_ID'
const DD_CLIENT_TOKEN = 'REPLACE_DD_CLIENT_TOKEN'
const ENVIRONMENT = 'REPLACE_ENVIRONMENT'
const VERSION = 'REPLACE_VERSION'
const DD_SESSION_SAMPLE_RATE = 'REPLACE_DD_SESSION_SAMPLE_RATE'
const DD_SESSION_REPLAY_SAMPLE_RATE = 'REPLACE_DD_SESSION_REPLAY_SAMPLE_RATE'

if(IS_DD_ENABLED) {
    datadogRum.init({
        applicationId: DD_APPLICATION_ID,
        clientToken: DD_CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: 'neva',
        env: ENVIRONMENT,
        version: VERSION,
        sessionSampleRate: Number(DD_SESSION_SAMPLE_RATE),
        sessionReplaySampleRate: Number(DD_SESSION_REPLAY_SAMPLE_RATE),
        trackInteractions: false,
        trackResources: true,
        trackLongTasks: true,
    });

    datadogLogs.init({
        clientToken: DD_CLIENT_TOKEN,
        site: 'datadoghq.com',
        env: ENVIRONMENT,
        version: VERSION,
        forwardConsoleLogs: "all",
        forwardErrorsToLogs: true,
        sessionSampleRate: Number(DD_SESSION_SAMPLE_RATE)
    })
}

ReactDOM.render(
  <EndConversationModalProvider>
    <FeedbackModalProvider>
      <AriaLiveProvider>
        <UnreadMessagesProvider>
          <UnreadMessagesContext.Consumer>
            {value => (
              <App
                unreadMessagesList={value.unreadMessagesList}
                handleAddUnreadMessages={value.handleAddUnreadMessages}
                handleClearUnreadMessages={value.handleClearUnreadMessages}
                isWidgetPopup={value.isWidgetPopup}
              />
            )}
          </UnreadMessagesContext.Consumer>
        </UnreadMessagesProvider>
      </AriaLiveProvider>
    </FeedbackModalProvider>
  </EndConversationModalProvider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
